import { FC } from "react"
import classNames from "classnames"
import SVG from "react-inlinesvg"
import { IconName } from "../types/icon"

type Props = {
  name: IconName
  className?: string
  size?: number
}

const Icon: FC<Props> = ({ name, className, size = 24 }) => {
  return <SVG
    className={classNames("icon", `icon--${name}`, className)}
    src={`${process.env.PUBLIC_URL}/icons/${name}.svg`}
    cacheRequests
    width={size}
    height={size}
  />
}

export default Icon